import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { bulkOrder } from 'services/apiOrders';

const useBulkUpload = () => {
  const queryClient = useQueryClient();
  const {isPending, isSuccess, mutate: uploadBulkOrder} = useMutation({
    mutationFn: bulkOrder,
    onSuccess:(data)=>{
        queryClient.setQueryData(['bulkData'],data)
        queryClient.invalidateQueries({queryKey:['orderList']})
        toast.success('Upload Sucessful')
    },
    // onError:(error)=>{
    //     console.log("Error occurred when uploading bulk order",error)
    //        // ✅ If backend provides details, show them individually
    //         if (error?.data?.details && Array.isArray(error.data.details) && error.data.details.length > 0) {
    //             error.data.details.forEach((errMsg) => {
    //                 toast.error(errMsg);
    //             });
    //         }
    //         // ✅ Else, show the main backend message
    //         else if (error?.data?.message) {
    //             toast.error(error.data.message);
    //         }
    //         // ✅ Else, fallback to error.message
    //         else if (error?.message) {
    //             toast.error(error.message);
    //         }
    //         // ✅ Final fallback if nothing is available
    //         else {
    //             toast.error("Something went wrong. Please try again.");
    //         }
    //         }
    onError:(error)=>{
        console.log(
        "Error occurred when uploading bulk order",
        error?.data || error
        );

        // Multiple validation errors
        if (
            error?.data?.errors &&
            Array.isArray(error.data.errors) &&
            error.data.errors.length > 0
        ) {
            error.data.errors.forEach((errMsg) => {
                toast.error(String(errMsg));
            });

            return;
        }

        // Backend message
        if (error?.data?.message) {
            toast.error(error.data.message);
            return;
        }

        // Generic JS error
        if (error?.message) {
            toast.error(error.message);
            return;
        }

        toast.error("Something went wrong. Please try again.");
                }
    })

    return{isPending, isSuccess, uploadBulkOrder}
    }

export default useBulkUpload